exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loyalty-cart[data-v-fa3031ec] {\n  background-color: #fff;\n  background-image: url(\"/assets/pattern-tile.png\");\n  background-repeat: repeat;\n  background-position: left top;\n}\n", ""]);

// exports
